import type { IconSvgObject } from './types';

const ChartBubble02Icon: IconSvgObject = [
  ["circle", { cx: "5", cy: "8", r: "3", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "9", cy: "17", r: "4", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "17", cy: "8", r: "5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ChartBubble02Icon;
